import { render } from "./SportiveOffer.vue?vue&type=template&id=429cc399&scoped=true"
import script from "./SportiveOffer.vue?vue&type=script&lang=js"
export * from "./SportiveOffer.vue?vue&type=script&lang=js"

import "./SportiveOffer.vue?vue&type=style&index=0&id=429cc399&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429cc399"]])

export default __exports__